// extracted by mini-css-extract-plugin
export var actionText = "_ly-4";
export var container = "_ly-0";
export var leftSection = "_ly-1";
export var rightSection = "_ly-2";
export var settingsButton = "_ly-6";
export var settingsIcon = "_ly-7";
export var shortcut = "_ly-5";
export var shortcutGroup = "_ly-3";